__turbopack_context__.v({
  "container": "errorblock-module__3b6-RG__container",
  "text": "errorblock-module__3b6-RG__text",
});
